module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('h2', {
    staticClass: "cn",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/nav#r_idParaDest-5"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("3. BERGORT—AUTUMN 2000")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T’S CALLED ")]), _vm._v("B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERGORT. ")]), _vm._v("Call it what you want, we don’t care. We can’t pronounce it anyway, and we’re still better at this than most. We know now that the ones who brought us here, our parents, will never make themselves understood here. They’ll be mute outside these walls, worse than dumb, because they’ll try. They’ll hem and haw and stutter and think that they’re rolling their consonants and curling their vowels well enough to get along, believe it’s enough to stumble your way to what you want. But it’s not enough, it will never be enough. Their old-fashioned, black dress pants, shawls, and jewelry. How could that be enough? We’ve known this from the first day. How could it escape them? We’re foreigners here. And we will never be more than the sum of our limitations. For people like us it’s never enough to do our best.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So we decide right here on the scratched-up wooden floor of the living room in our new, old, shabby apartment with its toddler graffiti on the kitchen cabinets, with our stupid memories still in moving boxes next to the wall, still waiting for someone to grab hold of us. Someone to unpack us and connect us to all this newness. Here on the floor we decide we’re not like the things in the box. We can’t wait for anyone, and we can’t rely on the people in the kitchen, the ones who brought us here and then surrendered. They are nothing more than old clothes, old thoughts, and old languages.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We sit in silence. We hear them chopping and mumbling in the kitchen, complaining about the tahini in the store on the square, "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("about the acidic tomatoes, about the parsley, the olive oil, about how there are no vegetables worth the name. We look at each other, and you smile at me and stroke my cheek, push a lock of hair from my forehead. You’ve just learned a word that’s so funny. "), _c('i', [_vm._v("Kåldolmar. ")]), _vm._v("It’s something they served in the school cafeteria, something brown and gray that might contain meat. We’re not supposed to eat pork, but we don’t care. They serve it with potatoes—they serve everything with potatoes.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We sit on the floor and listen to them nagging and whining in the kitchen, and it feels like we’re alone here, just you and me. Like there are oceans and worlds, galaxies and universes, between us and the kitchen. A cold wind streams in from the warped balcony door and you whisper to me:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe we should eat "), _c('i', [_vm._v("kåldolmar")]), _vm._v(" instead.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And we laugh until we can’t breathe. This is where it begins. This is where we decide—it’s just us.")]), _vm._v(" "), _c('p', {
    staticClass: "image01"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/sb.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In the beginning, we never leave home except to go to school. I wait for you outside the barracks and hide behind bushes that lose their leaves in the fall, becoming just as bald and ugly as everything else. While counting the minutes on the big clock on the brick building on the other side of the schoolyard, I pick white berries from those bushes and feel them explode and drain through my fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s always gray, and it’s always raining—until it starts to snow. I can’t believe it at first, those flakes seem to come from nowhere, as easy as thoughts, as dreams, as wind. I’m freezing and jumping and shaking and waiting and waiting and waiting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And I wonder who goes to that big brick school, and why we have to go to these barracks, and I count the seconds that feel like minutes, like hours and days, until you finally come out the door, always first, always alone, always peering down toward the bushes until you catch sight of "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("me. And then it’s not cold anymore, not hopeless, then the seconds don’t feel like hours, the afternoon is no longer empty and endless, completely beyond clocks and time.")])]), _vm._v(" "), _c('p', {
    staticClass: "image01"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/sb.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This is autumn, this is winter—we exchange their "), _c('i', [_vm._v("Wayed Wayed ")]), _vm._v("for our “"), _c('i', [_vm._v("Razor Tongue” ")]), _vm._v("and “"), _c('i', [_vm._v("7 Days”")]), _vm._v(" and Britney. This fall, this winter we walk over the asphalt, between the sparse hedges and frozen grass, through a world that gets darker and darker until I doubt I’ll ever see the sun again, that it’s disappeared and left me alone. Just like everything else left me. Everything except you, my sister.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And we walk slowly back to them across the frozen asphalt, dragging our feet through fresh snow between the buildings, creating ditches and furrows, a trail to follow back. As if we’re Hansel and Gretel and don’t need to find a way home, but a way out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It gets cold so fast, and my feet are freezing in my old tennis shoes—the snow finds a way in under the tongue, through the hole in the sole, or up under my too short pants.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You grow too fast, little brother,” you say. “Soon we’re not gonna be able to afford those legs anymore.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The cold finds its way through my polyester jacket and my mustard yellow thrift store sweater, through T-shirts and skin, and pierces bone and marrow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re almost home,"), _c('i', [_vm._v(" habibi,")]), _vm._v("” you say. “Then we’ll run you a hot bath.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And we laugh because we have no bathtub, just a shower with a thin, weak stream of lukewarm water, but laughing warms me up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You say:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("“Cord, board, lord, afford.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("New words you have learned. They sound like bird calls in your mouth, completely alien, inhuman. But we know that they are the key, they mean everything. We’re here now, we have no choice, can’t change "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("our short pants, our crappy shoes, our cramped, depressing home. But we can practice this melody until we sing it more beautifully than anyone else. And when spring finally sheds its pale light over the yellow grass I chirp:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("“Row, hoe, mow, cow.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That doesn’t rhyme,” you say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And we laugh again, helplessly, breathlessly, until we collapse into the melting snowdrifts—two scrawny, lonely kids in an alien world.")]), _vm._v(" "), _c('p', {
    staticClass: "image01"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/sb.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sometimes when we get home the apartment is dark and empty, and we regret not hurrying more, running through the winter so we could have had more time alone in the almost warm darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Those afternoons by ourselves we put pillows on the floor so close to the TV we are almost inside it, and it is as close to happiness as I get in those early days. We learn the word "), _c('i', [_vm._v("flip,")]), _vm._v(" and we "), _c('i', [_vm._v("flip")]), _vm._v(" past the Arabic channels and straight to Ricki Lake or Oprah or reruns of "), _c('i', [_vm._v("Beverly Hills 90210")]), _vm._v(". We dip dry bread in hummus or baba ghanoush or whatever we find pushed into the back of the refrigerator, behind the acidic tomatoes and tasteless, rotting peppers. Then we just lie there, still cold but drowsy, eyes half-open, and you read the subtitles aloud to me in a voice so heavy and tired and warm that I dream I can wrap it around me like the thickest, softest blanket, and sleep until the cold rolls away, and the sun streams in through the gaps in the broken blinds and gives us back our world again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But usually one of them is home from their classes or their temporary jobs, with their sighs and groans, their tired eyes, their paltry quarrels, their halfhearted questions about homework and angry tirades and a raised, open palm when we say we don’t have any. How will we ever learn anything? This society is too weak, too easy. They will make up their own math quizzes and Arabic homework because they hear us "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("drifting away from it, drifting away from them, whispering and creeping:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("“Eat, sleet, meat, feet, beet, sweet.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("“Threat, wet, net, let, set, bet.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They can hear us croaking, almost singing. They can see our wings are growing.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76bf10bf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062337290_Chapter_3.vue
// module id = 78
// module chunks = 0